import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { AiEntitlementState } from '../../features/ai-entitlement';

export const aiEntitlementGuard: CanActivateFn = (_route, state) => {
  const entitlementState = inject(AiEntitlementState);
  const router = inject(Router);

  return entitlementState.loadOnce().pipe(
    map(() => {
      if (entitlementState.aiEntitlementEnabled()) {
        return true;
      }
      const isCases = state.url.startsWith('/cases/admin');
      router.navigate([isCases ? '/cases/admin/types' : '/investigations/admin/types']);
      return false;
    }),
    catchError(() => {
      router.navigate(['/unauthorized']);
      return of(false);
    }),
  );
};
